import { POINTS } from './constants';
import useFinancePaymentCard from './useFinancePaymentCard';

import BasePaymentSelectDetails from '../BasePaymentSelectDetails';

const FinancePaymentCard: React.FunctionComponent = function () {
  const { monthly } = useFinancePaymentCard();
  return (
    <BasePaymentSelectDetails
      title="Spread the cost with flexible monthly payments"
      points={POINTS}
      footerHeading={`From ${monthly}*`}
      footerSubheading="per month"
    />
  );
};

export default FinancePaymentCard;
